import React from "react";

const Slogan = () => {
  return <span className="header__logo-subtext">right to the point</span>;
};

export default Slogan;
